import React from 'react';
import PropTypes from 'prop-types';
import { Progress } from 'antd';
import './styles.scss';
import { FormattedMessage } from "react-intl";

const MyProgress = ({
  percent,
  progress,
  showText,
  className,
  type,
  option,
  isProgressUpload = false,
  children,
  showInfo = false,
}) => {
  const _renderContent = () => {
    if (type === 'text') {
      return (option || PROGRESS_STATUS)[progress]?.view || null;
    }
    return (
      <>
        {showText && <span className="text-percent">{percent}%</span>}
        {!isProgressUpload && (
          <Progress
            className="progress-upload-normal"
            percent={percent || 0}
            showInfo={showInfo}
          />
        )}
        {isProgressUpload && (
          <Progress
            className={`progress-upload-${
              percent === 100 ? 'completed' : 'pending'
            }`}
            percent={percent || 0}
            showInfo={showInfo}
          />
        )}
      </>
    );
  };
  return (
    <div id="my-progress" className={className}>
      {_renderContent()}
      {children}
    </div>
  );
};

export default MyProgress;

MyProgress.propTypes = {
  percent: PropTypes.number,
  className: PropTypes.string,
  showText: PropTypes.bool,
  type: PropTypes.oneOf(['percent', 'text']),
};

MyProgress.defaultProps = {
  showText: true,
  type: 'percent',
};

const PROGRESS_STATUS = {
  NA: { value: 1, view: <span className="not-available"><FormattedMessage id="progress.status.na" /></span> },
  InProgress: {
    value: 2,
    view: <span className="in-progress"><FormattedMessage id="progress.status.in_progress" /></span>,
  },
  Completed: { value: 3, view: <span className="completed"><FormattedMessage id="progress.status.completed" /></span> },
};
